module.exports = __webpack_public_path__ + "static/img/banner.92f09ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/banner.svg
// module id = DXJQ
// module chunks = 72